import { render, staticRenderFns } from "./RecoverAccount.vue?vue&type=template&id=6d42af8a&scoped=true&"
import script from "./RecoverAccount.vue?vue&type=script&lang=js&"
export * from "./RecoverAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42af8a",
  null
  
)

export default component.exports